export default __webpack_public_path__ + "static/media/singleNewsHeader.94ce6f77.png";